module.exports = __webpack_public_path__ + "static/media/Ashley Johnson Headshot.c8393ef8.jpeg";